import TextButton from "@components/Article/TextButton";
const View = ({ ...item }: any) => {
  return <TextButton {...item} />;
};

View.strapiName = "story.text-button-component";

export default View;
